import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ activeCategory, onCategoryChange }) => {
  const categories = [
    { 
      id: 'all', 
      label: 'All Templates', 
      icon: 'Mail',
      description: 'View all email templates'
    },
    { 
      id: 'technology', 
      label: 'Technology', 
      icon: 'Cpu',
      description: 'Product announcements and innovations'
    },
    { 
      id: 'educational', 
      label: 'Educational', 
      icon: 'GraduationCap',
      description: 'Patient education and information'
    },
    { 
      id: 'trust', 
      label: 'Trust Building', 
      icon: 'Shield',
      description: 'Building patient confidence'
    },
    { 
      id: 'seasonal', 
      label: 'Seasonal', 
      icon: 'Calendar',
      description: 'Holiday and awareness campaigns'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 mb-6 shadow-sm">
      <h3 className="text-base md:text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Filter" size={20} />
        Filter by Category
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={`flex flex-col items-start p-4 rounded-lg border-2 transition-all duration-250 ${
              activeCategory === category?.id
                ? 'shadow-sm'
                : 'border-border bg-background hover:bg-muted/50'
            }`}
            style={activeCategory === category?.id ? {
              borderColor: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 1)))',
              backgroundColor: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 0.05)))'
            } : {}}
            aria-pressed={activeCategory === category?.id}
          >
            <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3" style={activeCategory === category?.id ? {
              backgroundColor: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 0.1)))'
            } : { backgroundColor: 'var(--color-muted)' }}>
              <Icon 
                name={category?.icon} 
                size={20} 
                color={activeCategory === category?.id ? '#1E293B' : 'currentColor'}
              />
            </div>
            <span className={`text-sm font-medium mb-1 ${
              activeCategory === category?.id ? 'text-primary' : 'text-foreground'
            }`}>
              {category?.label}
            </span>
            <span className="text-xs text-muted-foreground line-clamp-2">
              {category?.description}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;